module.exports = __webpack_public_path__ + "media/images/flags/16/Latvia-2f6e4f69ed25cb078e4fa06ba11a0e08.png";